import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../icon/icon.module';
import { CandidateRatingComponent } from './candidate-rating.component';

@NgModule({
  declarations: [CandidateRatingComponent],
  imports: [IconModule, CommonModule],
  exports: [CandidateRatingComponent],
})
export class CandidateRatingModule {}
export { CandidateRatingComponent } from './candidate-rating.component';
